module.exports = __webpack_public_path__ + "img/24.b0d93888.gif";